import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import router from './router/index'
import store from './store/store.js'
import VueJsonp from 'vue-jsonp'
import commonInstall from 'utils/js/commonInstall' //通用工具
import VueLazyload from 'vue-lazyload' //图片懒加载
import ElementUI from 'element-ui'; //ui框架
// import 'element-ui/lib/theme-chalk/index.css';
import 'utils/css/theme/index.css';
import 'utils/css/elementOften.css';
//富文本插件样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

Vue.config.productionTip = false
Vue.use(VueJsonp);
Vue.use(VueLazyload, {
  error: require('./assets/images/agency-portal/defadult_shcool.png'),
  loading: require('./assets/images/agency-portal/defadult_shcool.png')
})
Vue.use(commonInstall);
Vue.use(ElementUI);

router.afterEach((to, from, next) => {
  if (to && from && to.path != from.path) {
    window.scrollTo(0, 0);
  }
});
//多行溢出问题
Vue.filter('omitValue', function (value, num) {
  let agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf("chrome") == '-1') {
    if (value&&value.length >= num) {
      return value.slice(0, num) + '...';
    }
  }
  return value;
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
